import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitoplagharcab() {



  const cardData = {
    keyword: " Mumbai to Palghar Cab",


"headingDescription": "Royal Route Cab offers reliable Mumbai to Palghar cab service, providing safe, comfortable, and affordable short-distance travel for families, couples, corporate travelers, and weekend tourists. Palghar is a scenic coastal district in Maharashtra located approximately 90–110 km from Mumbai, known for its beaches, forts, greenery, and peaceful environment. Our professional drivers ensure a smooth and stress-free journey via well-connected highways, making it an ideal quick getaway from Mumbai. We offer flexible options including one-way drops, round trips, weekend packages, and customized travel plans. Our fleet includes economy sedans, SUVs, Innova, Ertiga, Innova Crysta, and Tempo Travellers suitable for all group sizes. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for Mumbai to Palghar cab service.",

"topPlaces": [
  {
    "title": "Kelva Beach",
    "description": "Kelva Beach is one of the most popular beaches in Palghar known for its long sandy coastline, peaceful atmosphere, and scenic coconut trees. It is ideal for weekend relaxation, sunset views, and family outings, making it a favorite destination for travelers coming from Mumbai."
  },
  {
    "title": "Shirgaon Fort",
    "description": "Shirgaon Fort is a historic coastal fort located near the Arabian Sea, offering a glimpse into Maharashtra’s rich history. It is a quiet and less crowded place, perfect for exploration, photography, and enjoying sea views."
  },
  {
    "title": "Tungareshwar Wildlife Sanctuary",
    "description": "Tungareshwar Wildlife Sanctuary is a lush green forest area near Palghar offering trekking trails, waterfalls, and wildlife sightings. It is a popular destination for nature lovers and adventure enthusiasts seeking a refreshing escape from city life."
  },
  {
    "title": "Jivdani Temple",
    "description": "Jivdani Temple, located on a hill near Virar, is a famous religious site dedicated to Goddess Jivdani. Visitors climb steps to reach the temple and enjoy panoramic views of the surrounding region, making it a spiritual and scenic destination."
  },
  {
    "title": "Arnala Beach",
    "description": "Arnala Beach is a clean and calm beach near Virar known for its peaceful environment and fewer crowds. It is ideal for relaxing, picnics, and enjoying coastal beauty close to Mumbai."
  },
  {
    "title": "Arnala Fort",
    "description": "Arnala Fort is a sea fort located on an island near Arnala Beach, accessible by boat. It offers historical exploration along with scenic sea views, making it a unique attraction for visitors."
  },
  {
    "title": "Surya Dam",
    "description": "Surya Dam is a scenic location surrounded by hills and greenery, offering a peaceful environment for picnics and relaxation. It is a lesser-known but beautiful destination in the Palghar region."
  },
  {
    "title": "Chinchoti Waterfalls",
    "description": "Chinchoti Waterfalls is a seasonal waterfall located within forest areas, popular during monsoon for trekking and nature trips. It attracts adventure seekers and groups looking for a refreshing outdoor experience."
  },
  {
    "title": "Tarapur Beach",
    "description": "Tarapur Beach is a quiet and clean beach in Palghar known for its calm surroundings and minimal crowd. It is perfect for peaceful walks and enjoying the natural beauty of the Konkan coastline."
  },
  {
    "title": "Mahim Beach Palghar",
    "description": "Mahim Beach in Palghar is a serene coastal destination ideal for relaxation, photography, and enjoying sunset views. It offers a calm environment compared to busy city beaches, making it a great short trip destination."
  }
],






services: [
  {
    name: "Mumbai to Palghar Cab",
    description: "Mumbai to Palghar cab service offers a fast, comfortable, and reliable journey to this nearby coastal district. Ideal for daily commuters, business travel, and weekend trips, this service ensures smooth highway travel. Professional drivers and clean vehicles enhance safety. It guarantees a hassle-free travel experience."
  },
  {
    name: "Mumbai to Palghar Taxi",
    description: "Mumbai to Palghar taxi provides convenient and private travel with door-to-door pickup. This service is ideal for short intercity travel with flexible schedules. Comfortable seating ensures a pleasant ride. It guarantees a smooth and reliable journey."
  },
  {
    name: "Mumbai to Palghar Cab Service",
    description: "Mumbai to Palghar cab service offers reliable transportation with multiple vehicle options. Suitable for office travel, family trips, and quick getaways. Well-maintained vehicles and trained drivers ensure comfort. It ensures a safe and smooth journey."
  },
  {
    name: "Mumbai to Palghar Taxi Service",
    description: "Mumbai to Palghar taxi service ensures dependable travel with professional drivers and comfortable vehicles. This service is ideal for daily commuting and short-distance travel. Flexible booking options enhance convenience. It guarantees a smooth experience."
  },
  {
    name: "Cab from Mumbai to Palghar",
    description: "Cab from Mumbai to Palghar offers a convenient way to travel between cities with complete comfort. This service is perfect for private travel needs. Professional drivers ensure safe journeys. It ensures a relaxed and easy ride."
  },
  {
    name: "Taxi from Mumbai to Palghar",
    description: "Taxi from Mumbai to Palghar provides reliable and quick travel for individuals and groups. This service ensures smooth road journeys with experienced drivers. Comfortable seating enhances the experience. It guarantees a dependable ride."
  },
  {
    name: "Mumbai to Palghar Cab Booking",
    description: "Mumbai to Palghar cab booking allows customers to reserve their ride easily with flexible options. Travelers can choose vehicle type, pickup point, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai to Palghar Taxi Booking Online",
    description: "Mumbai to Palghar taxi booking online provides a quick and easy way to plan your trip. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Mumbai to Palghar Cab Price",
    description: "Mumbai to Palghar cab price varies based on vehicle type and travel duration. Transparent pricing ensures no hidden charges. Customers can choose budget or premium options. It helps in planning travel efficiently."
  },
  {
    name: "Mumbai to Palghar Taxi Fare",
    description: "Mumbai to Palghar taxi fare is designed to be affordable and transparent. Fare depends on route and vehicle type. Customers receive clear pricing before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Palghar One Way Cab",
    description: "Mumbai to Palghar one way cab offers economical travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and budget-friendly travel."
  },
  {
    name: "Mumbai to Palghar Round Trip Taxi",
    description: "Mumbai to Palghar round trip taxi provides complete travel solutions including return journeys. Ideal for business visits and family outings. Flexible schedules make travel easy. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai to Palghar Innova Cab",
    description: "Mumbai to Palghar Innova cab is perfect for families and groups seeking spacious and comfortable travel. Premium seating ensures a smooth ride. Ideal for group travel. It ensures a comfortable experience."
  },
  {
    name: "Mumbai to Palghar Ertiga Cab",
    description: "Mumbai to Palghar Ertiga cab offers affordable and spacious travel for small groups. Comfortable seating and good mileage make it ideal for short trips. It ensures a pleasant journey."
  },
  {
    name: "Mumbai to Palghar Sedan Cab",
    description: "Mumbai to Palghar sedan cab is ideal for individuals and couples seeking economical travel. Sedans offer smooth rides and comfort. Professional drivers ensure safety. It ensures a relaxed journey."
  },
  {
    name: "Mumbai to Palghar SUV Taxi",
    description: "Mumbai to Palghar SUV taxi provides spacious and comfortable travel for families and groups. SUVs offer extra space and better comfort. Suitable for short-distance journeys. It ensures a comfortable experience."
  }
],

tableData: [
  ["Mumbai to Palghar Cab", "Mumbai to Palghar Taxi"],
  ["Mumbai to Palghar Cab Service", "Mumbai to Palghar Taxi Service"],
  ["Cab from Mumbai to Palghar", "Taxi from Mumbai to Palghar"],
  ["Mumbai to Palghar Cab Booking", "Mumbai to Palghar Taxi Booking Online"],
  ["Mumbai to Palghar Cab Price", "Mumbai to Palghar Taxi Fare"],
  ["Mumbai to Palghar One Way Cab", "Mumbai to Palghar Round Trip Taxi"],
  ["Mumbai to Palghar Innova Cab", "Mumbai to Palghar Ertiga Cab"],
  ["Mumbai to Palghar Sedan Cab", "Mumbai to Palghar SUV Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Palghar Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Palghar cab service, ideal for daily travel, family trips, and weekend getaways."
  },
  {
    WhyChooseheading: "Experienced Local Route Drivers",
    WhyChoosedescription: "Our drivers are well-trained and familiar with Mumbai to Palghar routes, ensuring safe and timely travel."
  },
  {
    WhyChooseheading: "Perfect for Short Trips & Weekend Travel",
    WhyChoosedescription: "Palghar is known for beaches and peaceful surroundings, making it perfect for quick trips from Mumbai."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or same-day return options for Palghar travel."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Palghar cab service operates 24/7, allowing flexible departure anytime as per your plan."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Local Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for Mumbai to Palghar cab bookings due to punctual service and reliable drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Palghar cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Palghar for one-way and round trips." },
  { question: "What is the distance between Mumbai and Palghar?", answer: "The distance is approximately 90 to 110 km and takes around 2 to 3 hours depending on traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Palghar cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Is this suitable for same-day return?", answer: "Yes, same-day return trips are available for Palghar travel." },
  { question: "Do you provide weekend trip packages?", answer: "Yes, we provide customized weekend travel packages." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for weekends and peak travel time." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Mahesh Patil",
    feedback: "The Mumbai to Palghar journey with Royal Route Cabs was very smooth and comfortable. The driver was punctual and the ride quality was excellent throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha More",
    feedback: "Great experience traveling from Mumbai to Palghar. The cab was clean, service was reliable, and the overall journey felt safe and stress-free.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Palghar Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-palghar-cab.jpg", // replace if needed
  "description": "Book Mumbai to Palghar cab service with Royal Route Cabs for safe, reliable, and affordable local and outstation travel. Available for one-way and round-trip journeys with sedan, SUV, Innova, and Ertiga vehicles. 24x7 taxi service from Mumbai to Palghar.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999", // approx starting fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-palghar-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Palghar Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Palghar cab with Royal Route Cabs. Safe and affordable local and outstation taxi service with sedan, SUV, Innova & Ertiga cars. 24x7 reliable travel."
  />

  <meta
    name="keywords"
    content="mumbai to palghar cab, mumbai to palghar taxi, mumbai to palghar cab service, mumbai to palghar taxi service, cab from mumbai to palghar, taxi from mumbai to palghar, mumbai to palghar cab booking, mumbai to palghar taxi booking online, mumbai to palghar cab price, mumbai to palghar taxi fare, mumbai to palghar one way cab, mumbai to palghar round trip taxi, mumbai to palghar innova cab, mumbai to palghar ertiga cab, mumbai to palghar sedan cab, mumbai to palghar suv taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/63.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoplagharcab;